module.exports = __webpack_public_path__ + "img/rs_blackL-logo.440bd53.png";